// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bZ7K","comment":"styles_comment__3DQzO"};